import {
  IdentityGrantCookie,
  retrieveStoredUserId,
  storeUserId,
  useIdentity,
} from "@equipmentshare/auth0-react";
import { heapEvent } from "@equipmentshare/heaper";
import { UniversalHeaderConsumable } from "@equipmentshare/universal-header";
import React from "react";
import styled from "styled-components";
import { useDispatch } from "~/Action";
import favicon from "~/images/favicon.png";
import { useLogout } from "~/Logout";
import { Time } from "~/Time";

export function UniversalHeader() {
  const dispatch = useDispatch();
  const logout = useLogout();
  const identity = useIdentity();

  const [environment, appName, appId] =
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("staging")
      ? (["staging", "E-logs (STAGE)", 5] as const)
      : (["production", "E-logs", 2] as const);

  const tokenGetter = () =>
    Promise.resolve({
      accessToken: identity.accessToken,
      idToken: identity.idToken,
    });

  const currentZone = Time.Zone.use();
  const [_, setTZPreference] = Time.Zone.usePreferences(identity.userId);

  const BASE_TIMEZONE_RIGHT = 330;
  const MIMIC_CHIP_CLEARANCE = 25;
  const MIMIC_CHIP_FIXED_WIDTH = 140;
  const MIMIC_CHIP_CHAR_WIDTH = 6;
  const mimicOffset = identity.isMimicked ? (
    MIMIC_CHIP_FIXED_WIDTH + identity.fullName.length * MIMIC_CHIP_CHAR_WIDTH + MIMIC_CHIP_CLEARANCE
  ) : 0;
  const timezoneLeftPosition = BASE_TIMEZONE_RIGHT + mimicOffset;

  return (
    <>
        <UniversalHeaderConsumable
          app={{ id: appId, name: appName, icon: favicon }}
          environment={environment}
          tokenGetter={tokenGetter}
          logout={logout}
          userIdentity={identity}
          getStoredActiveUserId={retrieveStoredUserId}
          setStoredActiveUserId={storeUserId}
          writeIdentityGrantCookie={IdentityGrantCookie.write}
        />
      <UniversalHeader.TimezoneSlot right={timezoneLeftPosition}>
        <Time.Zone.Select
          selected={currentZone}
          select={(zone) => {
            heapEvent("E-Logs - Fleet - Click - Timezone change", {
              from_timezone: currentZone.zone,
              to_timezone: zone.zone,
            });
            setTZPreference(zone);
            dispatch(Time.Zone.Action.create(zone));
          }}
        />
      </UniversalHeader.TimezoneSlot>
    </>
  );
}

type TimezoneSlotProps = {
  readonly right: number
};

export namespace UniversalHeader {
  export const height = () => "56px";

  export const TimezoneSlot = styled.div<TimezoneSlotProps>`
    position: fixed;
    top: 0;
    right: ${props => `${props.right}px`};
    height: ${() => height()};
    display: flex;
    align-items: center;
    z-index: 1000;
  `;
}
